import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { walkInQueryKeys, walkInQueryOptions } from './walk-in.queries';

export function useActiveWalkIn(viewerId?: string | null) {
  const client = useQueryClient();
  const query = useQuery(walkInQueryOptions.active(viewerId));

  useEffect(() => {
    if (!viewerId || !('serviceWorker' in navigator)) return;
    const refresh = (event: MessageEvent) => {
      if (event.data?.type === 'PUSH_RECEIVED') {
        void client.invalidateQueries({ queryKey: walkInQueryKeys.active(viewerId) });
      }
    };
    navigator.serviceWorker.addEventListener('message', refresh);
    return () => navigator.serviceWorker.removeEventListener('message', refresh);
  }, [client, viewerId]);

  return query;
}
